import React, { PureComponent } from 'react';
import { I18n } from 'react-redux-i18n';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { REDUCER_NAME as COMMON_REDUCER_NAME } from '../../../app/commonReducer';
import ScrollComponent from '../../../common/ScrollComponent';
import EventEmitter, {
  SHOW_GUEST_POPUP,
  TICKER_ADDED_TO_WL,
} from '../../../helpers/EventEmitter';
import Const from '../../watchlist/Const';
import './add-to-watch-list.scss';
import { appendTickerToWatchlist } from '../reducer';
import { isNotLoginOrExpired } from '../../../helpers/Common';

class AddToWatchList extends PureComponent {
  listRef = React.createRef();
  rootRef = React.createRef();
  state = {
    top: null,
    left: null,
    buttonStatus: {},
  };

  getListUserWatchlist = () => {
    const { listUserWatchlist, type } = this.props;
    return listUserWatchlist.filter(wl => wl.typeCode === type);
  };

  onMouseEnter = e => {
    const listHeight = this.listRef.current.scrollHeight;
    const { bottom: lmBottom } = document
      .getElementById('root')
      .getBoundingClientRect();
    const {
      right: rootRight,
      top: rootTop,
    } = this.rootRef.current.getBoundingClientRect();
    let top = rootTop;
    if (top + listHeight > lmBottom) {
      top = top - listHeight + 30;
    }

    this.setState({
      top,
      left: rootRight,
    });
  };

  onMouseLeave = () => {
    this.setState({
      left: null,
      top: null,
    });
  };

  appendToWatchlist = async wlId => {
    const { buttonStatus } = this.state;
    const { user } = this.props;
    if (isNotLoginOrExpired(user)) {
      EventEmitter.dispatch(SHOW_GUEST_POPUP);
      return;
    }
    if (buttonStatus[wlId]) {
      return;
    }
    this.setState({
      buttonStatus: {
        ...buttonStatus,
        [wlId]: 'loading',
      },
    });
    const { organCode, appendTickerToWatchlist } = this.props;
    const data = {
      organCode,
      watchListId: wlId,
      cacheKey: new Date().getTime(),
    };
    const isSuccess = await appendTickerToWatchlist(data);
    EventEmitter.dispatch(TICKER_ADDED_TO_WL, {
      organCode,
      watchListId: wlId,
    });
    this.setState({
      buttonStatus: {
        ...buttonStatus,
        [wlId]: isSuccess,
      },
    });
  };

  getButton = wlId => {
    const { buttonStatus } = this.state;
    const status = buttonStatus[wlId];
    if (!status) {
      return (
        <div onClick={() => this.appendToWatchlist(wlId)} className="add-btn">
          {I18n.t('watchListCommon.add')}
        </div>
      );
    }

    return <div className="add-btn done">{I18n.t('watchListCommon.done')}</div>;
  };

  render() {
    const { top, left } = this.state;
    const listUserWatchlist = this.getListUserWatchlist();
    if (!listUserWatchlist.length) {
      return null;
    }
    return (
      <div
        ref={this.rootRef}
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
        className="watchlist-popup__body--item add-to-watchlist"
      >
        <div>
          <i className="icon-view-table" />
          {I18n.t('watchListCommon.addToWatchlist')}
        </div>
        <i className="icon-caret-right" />
        <div
          style={{
            top,
            left,
            maxHeight: top && left ? 130 : 0,
            overflow: 'hidden',
          }}
          ref={this.listRef}
          className="list-watchlist"
        >
          <ScrollComponent appendStyle={{ maxHeight: 130 }}>
            {listUserWatchlist.map((wl, index) => (
              <div
                key={index}
                className="watchlist-popup__body--item d-flex justify-content-between"
              >
                {wl.text}
                {this.getButton(wl.watchListId)}
              </div>
            ))}
          </ScrollComponent>
        </div>
      </div>
    );
  }
}

AddToWatchList.propTypes = {
  type: PropTypes.string,
};

AddToWatchList.defaultProps = {
  type: Const.watchListType.CUSTOM,
};

const mapStateToProps = state => ({
  listUserWatchlist: state[COMMON_REDUCER_NAME].listUserWatchlist,
  user: state.userInfo,
});

const mapDispatchToProps = {
  appendTickerToWatchlist,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AddToWatchList);
